import { render, staticRenderFns } from "./materialCard.vue?vue&type=template&id=12c21843&scoped=true&"
import script from "./materialCard.vue?vue&type=script&lang=js&"
export * from "./materialCard.vue?vue&type=script&lang=js&"
import style0 from "./materialCard.vue?vue&type=style&index=0&id=12c21843&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c21843",
  null
  
)

export default component.exports